<template>
  <div>
    <div class="row">
      <p class="mb-4">
        This is designed to efficiently manage and track status of orders. This
        offers a quick view of orders, where you can effortlessly place orders
        and track the status of your rented space.
      </p>
    </div>
    <div class="row">
      <h5 class="underline-offset">&nbsp; All Orders &nbsp;</h5>
      <hr class="custom-hr" />
    </div>
    <div class="d-flex flex-row align-items-center mb-2">
      <div
        class="mdi mdi-information-outline me-3"
        style="color: #3366cc; font-size: 30px !important"
      ></div>
      <div class="text-muted mb-1">
        In this view, you can see the status of all your orders
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-row">
              <b-form-group
                description="Search Keyword"
                class="me-3 custom-fg-width"
              >
                <form class="d-flex">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="custom-search-icon">
                        <i class="bx bx-search-alt-2"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      class="rounded-0 custom-input"
                      v-model="search.keyword"
                      type="search"
                      placeholder="Search here..."
                      @keydown.enter.prevent="isSearching = true; getCampaigns();"
                      @search="resetSearch"
                    ></b-form-input>
                  </b-input-group>
                </form>
              </b-form-group>
            </div>
            <!-- <b-col cols="4" class="ta-left">
            </b-col> -->
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :busy="isLoading"
                  :items="campaignList"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  class="table-check"
                  :filter="filter"
                >
                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle me-2"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>

                  <template #cell(campaign_name)="data">
                    <!-- <p>{{ data.item.name }}</p> -->
                    <b-link class="fw-medium" @click="viewCampaignDetails(data.item.id)">
                      {{ data.item.campaign_name }}
                      <!-- <i class="bx bxs-pencil bx-xs bx-fw"></i> -->
                    </b-link>
                  </template>

                  <template #cell(order_no)="data">
                    <div>{{ data.item.order_no }}</div>
                  </template>

                  <template #cell(total_amount)="data">
                    <div>PHP {{ (data.item.total_amount).toLocaleString() }}</div>
                  </template>

                  <template #cell(total_release)="">
                    <div>PHP 0</div>
                    <!-- <div>{{ data.item.total_release }}</div> -->
                  </template>

                  <template #cell(fulfilled)="">
                    <div>Self Fulfilled</div>
                    <!-- <div>{{ data.item.fulfilled }}</div> -->
                  </template>

                  <template #cell(created_by)="data">
                    <div>{{ data.item.created_by }}</div>
                  </template>

                  <template #cell(created_at)="data">
                    <div>{{ data.item.created_at | formatDate }}</div>
                    <!-- <div>{{ data.item.fulfilled }}</div> -->
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row g-0 text-center" v-if="campaignTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <!-- end table responsive -->

            <!-- </div> -->
            <div class="row g-0 text-center text-sm-start" v-if="campaignTotalRows > 10">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <label class="col-form-label d-inline-block me-4"
                      >Display:</label
                    >
                    <div class="d-inline-block">
                      <b-form-group label-for="display-record">
                        <b-form-select
                          @change="currentPage = 1; getCampaigns()"
                          class="form-select shadow-none w-fit"
                          id="display-record"
                          v-model="perPage"
                          :options="pageOptions"
                        ></b-form-select>
                      </b-form-group>
                    </div>
                    <!-- <div class="form-group row pull-left">
                      </div> -->
                  </div>
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                      v-if="campaignTotalRows > perPage"
                    >
                      <!-- pagination -->
                      <b-pagination
                        @input="getCampaigns"
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="campaignTotalRows"
                        :per-page="perPage"
                        limit="1"
                        first-number
                        last-number
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end row -->
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
// import Swal from "sweetalert2";
import appConfig from "@/app.config";
import {
  layoutMethods,
  layoutComputed,
  campaignMethods,
  campaignComputed,
} from "@/state/helpers";
import { getModuleAccess } from '@/helpers/helper.js'

/**
 * Users list component
 */
export default {
  page: {
    title: "Campaigns",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      // title: "User",
      campaigns: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      sortBy: "id",
      sortDesc: true,
      search: {
        keyword: "",
      },
      fields: [
        {
          key: "campaign_name",
          label: "Marketing Campaign Name",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "order_no",
          label: "Order Number",
          sortable: false,
          tdClass: "align-middle",
        },
        // {
        //   key: "total_amount",
        //   label: "Total Balance",
        //   sortable: true,
        //   tdClass: "align-middle",
        // },
        // {
        //   key: "total_release",
        //   label: "Total Release",
        //   sortable: true,
        //   tdClass: "align-middle",
        // },
        {
          key: "fulfilled",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          label: "Created By",
          key: "created_by",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          label: "Date Created",
          key: "created_at",
          sortable: false,
          tdClass: "align-middle",
        },
      ],
      campaignNameFilter: [{ text: "All", value: null }],
      statusFilter: [{ text: "All", value: null }],
      submitted: false,
      campaignTotalRows: 0,
      access: {
        create: false,
        read: false,
        update: false,
        delete: false,
      },
      isLoading: false,
      isSearching: false,
    };
  },
  components: {
  },
  computed: {
    ...layoutComputed,
    ...campaignComputed,
  },
  async mounted() {
    this.changeBreadCrumb({
      breadCrumbs: [{ text: "My Space", to: {} }],
    });
    this.changeBackButton({
      value: false,
    });

    this.getCampaigns();

    var success = this.$route.query.success;

    if(parseInt(success) === 1){
      this.$router.replace({ query: null });
      this.$toast.showToast('success', "Success", "Your order has been submitted.");
    }
    
    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess("Manage Space", "My Space")
      .then((access) => {
        this.access = access
      }
    );
  },
  methods: {
    ...layoutMethods,
    ...campaignMethods,
    getCampaigns() {
      this.isLoading = true;
      this.currentPage = this.isSearching ? 1 : this.currentPage;
      let params = {
        page: this.currentPage,
        rows: this.perPage,
        search: this.search.keyword,
        sort: this.sortBy,
        sortDesc: this.sortDesc
      };

      this.getCampaignList(params).then(() => {
        this.isLoading = false;
        this.isSearching = false;
        this.campaigns = this.campaignList;
        this.campaignTotalRows = this.campaignsTotal;
      });
    },
    viewCampaignDetails(campaignId) {
    if (!this.access.read) {
        this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
        return
      }
      this.$router.push({ path: `campaign-details/${campaignId}` })
    },
    async resetSearch() {
      if(!this.search.keyword) {
        this.search.keyword = "";
        this.currentPage = 1;
        this.perPage = 10;
        this.sortBy = "id";
        this.sortDesc = true;
        this.isSearching = false;
        await this.getCampaigns();
      }
    }
  },
};
</script>

<style scoped>
.cstm-badge {
  color: #fff;
  background-color: #0062ff;
  border-radius: 10px;
  margin-left: 10px;
}

.table {
  --bs-table-bg: transparent;
}

.table th {
  background-color: #f5f6f8;
}

.custom-search-icon {
  font-size: 1.5rem;
  background-color: transparent;
  border-right: 0px;
  border-radius: 5px 0px 0px 5px;
}

.custom-input {
  border-left: 0;
  border-radius: 0px 5px 5px 0px !important;
}

.table td {
  width: 400px;
}

.form-check-input {
  border-color: #7e93a059;
}

.underline-offset {
  text-decoration: underline;
  text-underline-offset: 11px;
  text-decoration-thickness: 2px;
  color: #f84b04;
}

.custom-hr {
  border: solid 1px dimgray !important;
  margin-left: 10px;
  width: 98.5%;
}

.custom-fg-width {
  width: 400px;
}
</style>
